/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteSkillRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/skills_messages.pb'
import {DeleteSkillResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/skills_messages.pb'


export const deleteSkill = (request: DeleteSkillRequest, options?: CashRequestOptions) => post<DeleteSkillRequest, DeleteSkillResponse>("/2.0/cash/delete-skill", request, {...options, rejectOnError: true })